export default __webpack_public_path__ + "static/media/upload.abadea67.svg";